"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchFilter = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_select_1 = require("react-select");
var AsyncSelect_1 = require("../../../components/AsyncSelect");
var named_1 = require("../../../utils/named");
var ClearIndicator_1 = require("../misc/ClearIndicator");
var IncludeExclude_1 = require("../misc/IncludeExclude");
var Wrapper_1 = require("./Wrapper");
var R = __importStar(require("../../../utils/ramda"));
var useFilter_1 = require("./useFilter");
var SearchFilter = function (_a) {
  var label = _a.label,
    filterId = _a.id,
    loadOptions = _a.loadOptions,
    startExpanded = _a.startExpanded,
    _b = _a.startMode,
    startMode = _b === void 0 ? "include" : _b,
    _c = _a.defaultOptions,
    defaultOptions = _c === void 0 ? [] : _c,
    _d = _a.placeholder,
    placeholder = _d === void 0 ? "Enter text" : _d,
    _e = _a.clearIndicatorText,
    clearIndicatorText = _e === void 0 ? "Clear" : _e,
    _f = _a.loadingText,
    loadingText = _f === void 0 ? "Fetching..." : _f,
    _g = _a.noOptionsText,
    noOptionsText = _g === void 0 ? "No matches" : _g,
    tooltip = _a.tooltip,
    tooltipIcon = _a.tooltipIcon,
    tooltipColor = _a.tooltipColor,
    tooltipIconColor = _a.tooltipIconColor,
    _h = _a.hideIncludeExclude,
    hideIncludeExclude = _h === void 0 ? false : _h,
    _j = _a.single,
    single = _j === void 0 ? false : _j,
    rest = __rest(_a, ["label", "id", "loadOptions", "startExpanded", "startMode", "defaultOptions", "placeholder", "clearIndicatorText", "loadingText", "noOptionsText", "tooltip", "tooltipIcon", "tooltipColor", "tooltipIconColor", "hideIncludeExclude", "single"]);
  var _k = (0, useFilter_1.useFilter)({
      filterId: filterId,
      defaultMode: startMode,
      defaultOptions: defaultOptions
    }),
    mode = _k.mode,
    optionsSelected = _k.optionsSelected,
    setMode = _k.setMode,
    setSelected = _k.setSelected,
    isActive = _k.isActive,
    isUnsaved = _k.isUnsaved,
    translation = _k.translation;
  var onChange = function (newValue) {
    return setSelected(newValue);
  };
  return (0, jsx_runtime_1.jsxs)(Wrapper_1.FilterWrapper, __assign({
    filterId: filterId,
    label: label,
    tooltip: tooltip,
    tooltipIcon: tooltipIcon,
    tooltipColor: tooltipColor,
    tooltipIconColor: tooltipIconColor,
    mode: mode,
    isActive: isActive,
    isUnsaved: isUnsaved,
    selectedCount: optionsSelected.length,
    startExpanded: startExpanded
  }, {
    children: [!hideIncludeExclude && (0, jsx_runtime_1.jsx)(IncludeExclude_1.IncludeExclude, {
      translation: translation,
      filterId: filterId,
      selectedMode: mode,
      onChange: setMode
    }), (0, jsx_runtime_1.jsx)("div", __assign({
      className: "multi-select type-ahead multiSelect"
    }, {
      children: (0, jsx_runtime_1.jsx)(AsyncSelect_1.AsyncSelect, __assign({}, rest, {
        cacheOptions: true,
        components: {
          LoadingMessage: (0, named_1.named)("LoadingMessage", function (props) {
            return (0, jsx_runtime_1.jsx)(react_select_1.components.LoadingMessage, __assign({}, props, {
              children: loadingText
            }));
          }),
          DropdownIndicator: function (_) {
            return null;
          },
          IndicatorSeparator: function (_) {
            return null;
          }
          // ClearIndicator: ClearIndicator(clearIndicatorText)
        },

        styles: {
          clearIndicator: ClearIndicator_1.ClearIndicatorStyles
        },
        onChange: onChange,
        value: optionsSelected,
        isMulti: !single,
        isClearable: true,
        placeholder: placeholder,
        loadOptions: loadOptions,
        noOptionsMessage: R.always(noOptionsText),
        openMenuOnClick: false,
        openMenuOnFocus: false
      }))
    }))]
  }));
};
exports.SearchFilter = SearchFilter;